const heading1 = [
  "M2.2 13.77V9h5.15v4.76h2.17V2.23H7.35v4.75H2.19V2.23H0v11.54h2.18zm13.8 0V2.23h-2.23l-2.15 1.3v2.4l2.15-1.34v9.18z"
];
export {
  heading1
};
//# sourceMappingURL=heading1.js.map
